// Package Imports
import React from 'react';
import { Form, Select } from 'antd';

// Project Imports
import { DropdownInputProps } from 'components/dropdown/type';

const DropdownInput = ({
  label,
  name,
  required,
  optionList,
  message,
  style,
  values,
  disabled,
  onChange,
  placeholder,
  onSearch,
  showSearch,
  mode,
  allowClear,
  size = 'middle',
  className,
  filterOption,
  optionFilterProp,
}: DropdownInputProps) =>
  name !== undefined ? (
    <div
      className={
        disabled
          ? 'floating-disabled relative custom-dropdown'
          : 'relative custom-dropdown'
      }
    >
      {label ? (
        <label className="floating-label">
          {label} {required ? <span className="a8-error">*</span> : null}
        </label>
      ) : null}

      <Form.Item
        name={[name]}
        rules={[{ required, message }]}
        hasFeedback={required || !!values}
        style={style}
      >
        <Select
          onChange={onChange}
          placeholder={placeholder}
          options={optionList}
          showSearch={showSearch}
          onSearch={onSearch}
          filterOption={filterOption}
          mode={mode}
          disabled={disabled}
          size={size}
          // className={size === 'small' ? 'py-sm' : 'py-md'}
          allowClear={allowClear}
          className={className}
          value={values}
          optionFilterProp={optionFilterProp}
        />
      </Form.Item>
    </div>
  ) : (
    <div className="relative custom-dropdown dropdown-arrow-style">
      {label ? (
        <label className="floating-label">
          {label} {required ? <span className="a8-error">*</span> : null}
        </label>
      ) : null}
      <Select
        value={values}
        disabled={disabled}
        style={{ display: 'flex', justifyContent: 'center' }}
        onChange={onChange}
        options={optionList}
        placeholder="Select"
        showSearch={showSearch}
        onSearch={onSearch}
        filterOption={filterOption}
        size={size}
        // className={size === 'small' ? 'py-sm' : 'py-md'}
        allowClear={allowClear}
        className={className}
        optionFilterProp={optionFilterProp}
      />
    </div>
  );

export default DropdownInput;
